export const COMMUNICATION_INTENT_TTL_MS = 90 * 1000;

export const COMMUNICATION_INTENT_SATISFIED_GRACE_MS = 30 * 1000;
